import { PLAN_STATUS } from "@/data/plans";
import { TPlanStatus } from "@/types/plan";
import { TPlanActionType } from "../types.dashboard";

export function resolvePlanActionType({
  planStatus,
  cancelAt,
  isV1User,
  isMaxPlan,
  isCancelOnly,
}: {
  planStatus?: TPlanStatus;
  cancelAt?: number | null;
  isV1User: boolean;
  isMaxPlan: boolean;
  isCancelOnly: boolean;
}): TPlanActionType {
  const isPlanCancelled = planStatus === PLAN_STATUS.CANCELED;
  const isCancelling = !!cancelAt && !isPlanCancelled;
  const isTrialing = planStatus === PLAN_STATUS.TRIALING;
  const pastDue = planStatus === PLAN_STATUS.PAST_DUE;

  if (isMaxPlan) return "cancel";
  if (isV1User && !isPlanCancelled && !isTrialing && !pastDue) return "migrate";
  if (isCancelling) return "cancelling";
  if (planStatus === PLAN_STATUS.PAUSED) return "paused";
  if (
    isPlanCancelled ||
    planStatus === PLAN_STATUS.PAST_DUE ||
    planStatus === PLAN_STATUS.NOT_FOUND ||
    !planStatus
  )
    return "purchase";

  if (isTrialing) {
    return "trialing";
  }

  if (isCancelOnly) return "main-cancel";

  return "manage";
}
